module.exports = __webpack_public_path__ + "img/img-account.dd6a727b.png";